import { render, staticRenderFns } from "./RetoureShelfManager.vue?vue&type=template&id=ae605148&scoped=true"
import script from "./RetoureShelfManager.vue?vue&type=script&lang=js"
export * from "./RetoureShelfManager.vue?vue&type=script&lang=js"
import style0 from "./RetoureShelfManager.vue?vue&type=style&index=0&id=ae605148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae605148",
  null
  
)

export default component.exports